<template>
  <div id="app">
    <topbar v-if="showTopbar"></topbar>
    <maincontent></maincontent>
    <div v-show="upBtnShow" class="jom-up-btn" @click="scrTop"></div>
  </div>
</template>

<script>
  import topbar from './componentsMobile/topbar/topbar.vue'
  import maincontent from './componentsMobile/maincontent/maincontent.vue'

  export default {
    name: 'app',
    components: {
        topbar,
        maincontent,
    },
    data() {
        return {
            upBtnShow:false,
        }
    },
    methods: {
        scrTop(){
            $('html,body').animate({scrollTop:"0px"})
        },
      //  微信浏览器禁止改变字体大小
      forbiddenFontSize: function () {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          handleFontSize();
        } else {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
          }
        }

        function handleFontSize () {
          WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
          });
          WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', {
              'fontSize': 0
            });
          });
        }
      }
    },
    created() {
        var deviceDPI = {},
            _this=this
        if (window.screen.deviceXDPI != undefined) {
            deviceDPI.x = window.screen.deviceXDPI;
            deviceDPI.y = window.screen.deviceYDPI;
        }
        else {
            var tmpNode = document.createElement("DIV");
            tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
            document.body.appendChild(tmpNode);
            deviceDPI.x = parseInt(tmpNode.offsetWidth);
            deviceDPI.y = parseInt(tmpNode.offsetHeight);
            tmpNode.parentNode.removeChild(tmpNode);
        }
        this.GLOBAL.deviceDPI = deviceDPI
        $(window).scroll(()=>{
            if($(window).scrollTop()>0)
                _this.upBtnShow=true
            else
                _this.upBtnShow=false
        })
      $('#page-foot').css('display','block')
    },
    mounted(){
      this.forbiddenFontSize();

//      ios端el-popover弹窗弹出后点击事件被屏蔽问题
      let sUserAgent = navigator.userAgent;
      if (sUserAgent.indexOf('iPhone')>0) {
        document.getElementById('app').addEventListener('click',function  (){});
      }

      let dpRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
      console.log(dpRatio)
      if(window.screen.width*dpRatio < 1080 && window.screen.height*dpRatio < 1920){
        $('#app').addClass('device720p');
      } else {
        $('#app').addClass('device1080p');
      }
      //      设置主题色
      $('.theme-font').css('color', this.ARTICLE.theme);
      $('a').css('color', this.ARTICLE.theme);
      $('li.active span').css('color', this.ARTICLE.theme);
      $('.theme-background').css('background-color', this.ARTICLE.theme);
      $('.theme-border').css('border-color', this.ARTICLE.theme);
    }
  }
</script>


<style lang="scss" scoped>
    .jom-up-btn{
        position:fixed;
        right:10px;
        bottom:10px;
        width:35px;
        height:35px;
        background:url('./assets/img/arrow-top-active.png') no-repeat left top;
    }
    .jom-up-btn:hover{
        background:url('./assets/img/arrow-top-hover.png') no-repeat left top;
    }
</style>



// WEBPACK FOOTER //
// src/AppMobile.vue